import { useQuery } from '@tanstack/react-query'

import type { TimelineEntryType } from '@snootsvet/shared'

import { useOsApi } from '@/frontend/hooks/api/use-os-api'

/** Fetches the patient's merged timeline, newest first; every entry type when `types` is omitted. */
export function useGetPatientTimeline(patientId: string, types?: TimelineEntryType[]) {
  const api = useOsApi()

  return useQuery({
    queryKey: ['patient-timeline', patientId, types],
    queryFn: async () => {
      const response = await api.get('/patients/:patientId/timeline', {
        params: { patientId },
        query: { types },
      })
      if (!response.success) throw new Error(response.error.message)
      return response.data.entries
    },
    enabled: types === undefined || types.length > 0,
    // Keeps the feed on screen while a filter change refetches, but never shows
    // another patient's records while this one's load.
    placeholderData: (previous, previousQuery) =>
      previousQuery?.queryKey[1] === patientId ? previous : undefined,
  })
}
